export default __webpack_public_path__ + "static/media/card3.d91d9110.png";